import type { StatHelpTopic } from "./statHelp.js";
import { statHelpLabel } from "./statHelp.js";

type StatHelpButtonProps = {
  topic: StatHelpTopic;
  onHelp: (topic: StatHelpTopic) => void;
};

export function StatHelpButton({ topic, onHelp }: StatHelpButtonProps) {
  return (
    <button
      type="button"
      className="stat-help-btn"
      aria-label={statHelpLabel(topic)}
      onClick={() => onHelp(topic)}
    >
      <span aria-hidden="true">?</span>
    </button>
  );
}
